import { Configuration } from '@plant/genai-api-client';
import { AuthenticationApi, IdentificationApi } from '@plant/auth-api-client';

export class AuthService {
	constructor(token) {
		this.basePath = window.__env__.VUE_APP_AUTH_BASE_PATH;
		this._createAuthenticationApi(token);
		this._createIdentificationApi(token);
	}

	_createIdentificationApi(token) {
		const identificationConfiguration = new Configuration({
			basePath: this.basePath,
			baseOptions: {
				headers: { Authorization: `Bearer ${token}` }
			}
		});
		this.identificationApi = new IdentificationApi(identificationConfiguration);
	}

	_createAuthenticationApi(token) {
		const authenticationConfiguration = new Configuration({
			basePath: this.basePath,
			baseOptions: {
				headers: { Authorization: `Bearer ${token}` }
			}
		});
		this.authenticationApi = new AuthenticationApi(authenticationConfiguration);
	}

	async login(credentials) {
		const axiosResponse = await this.authenticationApi.loginControllerLogin(credentials);
		return axiosResponse.data;
	}

	async logout() {
		await this.authenticationApi.logoutControllerLogout();
	}

	async touch() {
		await this.authenticationApi.touchSessionControllerTouchSession();
	}

	async whoami() {
		const axiosResponse = await this.identificationApi.whoamiControllerWhoami();
		return axiosResponse.data;
	}
}

